import React from 'react'
import Person1 from '../../img/person1.jpg'
import Person2 from '../../img/person5.jpg'
import Person3 from '../../img/person4.jpg'

export function About() {
    return (

        <section id="about" class="mt-5">
            <div className="container">

                <div class="row pt-5 mt-3" style={{ width: '100%', margin: '1px auto' }}>
                    <div class="col-md-12 ">
                        <div class="text-center white-text">

                            <h1 class="display-4 mt-md-5 mt-lg-0 mb-5 font-weight-bold">
                                <strong>About us</strong>
                            </h1>

                            <h5 class="white-text " data-wow-delay="0.4s">
                                Hello Movie Trailers welcome to the website on this website
                            you will see entertaining programs, funny movies, <br />
                            cartoons and cultural entertainment
                    </h5>

                        </div>
                    </div>
                </div>

                <div className="row d-flex my-5 responsives">
                    <div class="col-md-6 d-flex ">
                        <div class="float-left">
                            <div class="avatar">
                                <img
                                    className="imgs"
                                    src={Person2}
                                    alt="Second sample avatar image" />
                            </div>
                        </div>
                        <div class="float-right" style={{ marginLeft: ' 70px', marginBottom: '2rem' }}>
                            <h4>
                                <strong>Iftikhor T</strong>
                            </h4>
                            <h6 class="font-weight-bold grey-text ">Frontend Developer</h6>
                            <p class="grey-text">I have done a lot of work in my field
                        and <br /> I have one a year of experience in this field.</p>
                            <a href="https://www.facebook.com/iftixor.turamuradov" target="_blank" class="p-2 m-2 fa-lg fb-ic">
                                <i class="fab fa-facebook-f"> </i>
                            </a>
                            <a class="p-2 m-2 fa-lg yt-ic">
                                <i class="fab  fa-youtube"> </i>
                            </a>
                            <a class="p-2 m-2 fa-lg ins-ic">
                                <i class="fab fa-instagram"> </i>
                            </a>
                        </div>
                    </div>

                    <div class="col-md-6 d-flex">
                        <div class="float-left">
                            <div class="avatar">
                                <img
                                    style={{ width: '100%' }}
                                    src="https://mdbootstrap.com/img/Photos/Avatars/img%20(20).jpg"
                                    alt="Second sample avatar image" />
                            </div>
                        </div>
                        <div class="float-right responsive">
                            <h4>
                                <strong>Maria Kate</strong>
                            </h4>
                            <h6 class="font-weight-bold grey-text ">Web Designer</h6>
                            <p class="grey-text"> I have more than 2 years of
                        experience in graphic design, <br />
                        creating logos for business and corporate identity.</p>
                            <a href="https://www.facebook.com/iftixor.turamuradov" target="_blank" class="p-2 m-2 fa-lg fb-ic">
                                <i class="fab fa-facebook-f"> </i>
                            </a>
                            <a class="p-2 m-2 fa-lg yt-ic">
                                <i class="fab  fa-youtube"> </i>
                            </a>
                            <a class="p-2 m-2 fa-lg ins-ic">
                                <i class="fab fa-instagram"> </i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>



            <div class="streak streak-photo streak-md">
                <div class="flex-center mask rgba-gradient">
                    <div class="container my-3">
                        <h3 class="text-center mb-2 pb-4 white-text font-weight-bold wow fadeIn" data-wow-delay="0.2s">
                            <strong>Some facts about us</strong>
                        </h3>
                        <div class="row text-center">
                            <div class="col-md-3 mb-2">
                                <h1 class="white-text mb-1 font-weight-bold">+950</h1>
                                <p class="white-text">Happy clients</p>
                            </div>
                            <div class="col-md-3 mb-2">
                                <h1 class="white-text mb-1 font-weight-bold">+150</h1>
                                <p class="white-text">Projects completed</p>
                            </div>
                            <div class="col-md-3 mb-2">
                                <h1 class="white-text mb-1 font-weight-bold">+85</h1>
                                <p class="white-text">Winning awards</p>
                            </div>
                            <div class="col-md-3">
                                <h1 class="white-text mb-1 font-weight-bold">+246</h1>
                                <p class="white-text">Cups of coffee</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </section >


    )
}

export default About

